<template>
  <div 
    :class="[
      'inline-block animate-spin rounded-full border-2',
      spinnerStyle[style],
      sizeClasses[size]
    ]"
    role="status"
  >
  </div>
</template>

<script setup lang="ts">
import type { ElementSizeType } from '@/types'
import { computed } from 'vue'
const props = withDefaults(defineProps<{
  size?: ElementSizeType
  style?: 'primary' | 'secondary' | 'outline' | 'danger' | 'light' | 'plain'
}>(), {
  size: 'md',
  style: 'primary'
})

const spinnerStyle = computed(() => ({
  primary: 'border-white border-r-transparent',
  secondary: 'border-white border-r-transparent',
  outline: 'border-gray-300 dark:border-gray-600 border-r-transparent',
  danger: 'border-white border-r-transparent',
  light: 'border-gray-300 dark:border-gray-600 border-r-transparent',
  plain: 'border-gray-300 dark:border-gray-600 border-r-transparent'
}))

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
  '2xl': 'h-24 w-24'
}
</script> 